import { Injectable } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { BehaviorSubject, Subject } from 'rxjs';

import { PermissionAction } from '../../shared/enums/permission-action.enum';
import { Acquisition } from '../../shared/models/acquisition.model';
import { File } from '../../shared/models/file.model';

export interface AcquisitionFilters {
  description: string;
  classification: string;
  created: string;
  fileType: string;
}

@Injectable()
export class SessionDataState {
  activeAcquisitionSort$ = new BehaviorSubject<Sort>({ active: 'created', direction: 'asc' });
  activeFileSort$ = new BehaviorSubject<Sort>({ active: 'created', direction: 'asc' });
  acquisitionFilters$ = new BehaviorSubject<AcquisitionFilters>({
    description: '',
    classification: '',
    created: null,
    fileType: '',
  });
  // Acquisitions that hold DICOM files
  dicomAcquisitions$ = new BehaviorSubject<Acquisition[]>([]);
  // Files that have been modified or deleted
  fileChanges$ = new Subject<File>();
  // Files that are being dragged
  fileDragging$ = new Subject<File | null>();
  // Files that need to be moved to another acquisition in client state
  fileMove$ = new Subject<{ file: File; acquisitionId: string }[]>();
  // Files that need to be renamed
  fileRename$ = new Subject<string>(); // file.file_id
  // Files that are shift-click selected
  fileSelection$ = new BehaviorSubject(new Set<string>()); // file.file_id
  originalTimezone$ = new BehaviorSubject(false);
  projectPermissions$ = new BehaviorSubject<Set<PermissionAction>>(new Set());
  runGearRulesOnMove$ = new BehaviorSubject(false);
}
